// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1987Y","buttons":"styles_buttons__-JkAn"};